<template>
  <div class="bg-white">
    <div
      class="editor"
      ref="editor"
      @drop.prevent
      @dragstart.prevent
      v-html="html"
    ></div>
  </div>
</template>

<script>
import Quill from "quill";
import AutoLinks from "quill-auto-links";
import "quill-paste-smart";
import "quill/dist/quill.snow.css";

Quill.register("modules/autoLinks", AutoLinks, true);

export default {
  name: "Editor",
  props: {
    value: {
      type: String,
      default: "<p><br></p>",
    },
  },
  data: () => ({
    editor: null,
    html: "",
  }),
  methods: {
    getText() {
      return this.editor.getText();
    },
    onTextChange() {
      this.$emit("input", this.editor.root.innerHTML.toString());
    },
  },
  created() {
    this.html = this.value;
  },
  mounted() {
    // https://github.com/SmallImprovements/quill-auto-links/blob/master/src/index.js
    // TODO: auto-link case insensitive HTTP vs http - really?
    // TODO: auto-link after Enter key
    const options = {
      modules: {
        autoLinks: true,
        keyboard: {
          bindings: {
            tab: {
              key: 9, // Tab
              handler: () => true,
            },
          },
        },
        toolbar: ["bold", "italic", "underline", "strike", "link", "clean"],
      },
      placeholder: "Start typing your message here...",
      theme: "snow",
    };
    this.editor = new Quill(this.$refs.editor, options);
    this.editor.on("text-change", this.onTextChange);
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/quill.custom";
</style>
